import * as React from "react";
import type { SVGProps } from "react";
const SvgCoins = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 8.667V6h5.333v2.667M9.333 6H10V3.333H4.667V6M11.886 9.448a2.667 2.667 0 1 1-3.772 3.771 2.667 2.667 0 0 1 3.771-3.771"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 11.333V14h6"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 8.667H3.333v2.667h4"
    />
  </svg>
);
export default SvgCoins;
